import "./src/styles/global.css";
import "./src/styles/algolia.css";
import "./src/styles/markdown.css";
import "./src/styles/jsfiles.css";
import wrapWithProvider from "./src/wrap-with-provider";
export const wrapRootElement = wrapWithProvider;
export const onServiceWorkerUpdateFound = () => window.location.reload();
